import React from 'react';
import { Content, Footer, Header, Sidebar } from 'components/Layout';
import Typography from '@mui/material/Typography';
import './MainLayout.css';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

class MainLayout extends React.Component {
  static isSidebarOpen() {
    return document
      .querySelector('.cr-sidebar')
      .classList.contains('cr-sidebar--open');
  }

  componentWillReceiveProps({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);
  }

  handleContentClick = () => {
    if (
      MainLayout.isSidebarOpen() &&
      ['xs', 'sm', 'md'].includes(this.props.breakpoint)
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    if (['xs', 'sm', 'md'].includes(breakpoint)) {
      this.openSidebar('close');
    } else {
      this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    if (openOrClose === 'open') {
      document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
    } else {
      document
        .querySelector('.cr-sidebar')
        .classList.remove('cr-sidebar--open');
    }
  }

  render() {
    const { children } = this.props;
    return (
      <main className="cr-app bg-light">
        <Sidebar />
        <Content fluid onClick={this.handleContentClick}>
          <Header />
          {children}
          {sessionStorage.getItem('AdminUser') !== 'Y' &&
            sessionStorage.getItem('Special_User1') !== 'Y' && (
              <Typography
                variant="subtitle2"
                color="white"
                textAlign={'center'}
                className="stcky-footer-ad"
                sx={{ py: 1 }}
              >
                <span style={{ color: 'yellow', fontWeight: 'bolder' }}>
                  Streamline Your Business:
                </span>{' '}
                Automize Your Operations!
                <a
                  href={
                    sessionStorage.getItem('CustomerType') === 'Corporate'
                      ? 'https://asktek.net/target_scm_supply_chain_managements'
                      : 'https://asktek.net/Target_Order_Management_System'
                  }
                  target="blank"
                  className={`flash-button`}
                >
                  {` know more `}
                </a>
              </Typography>
            )}
          <Footer />
        </Content>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </main>
    );
  }
}

export default MainLayout;
